import { render, staticRenderFns } from "./UserProfileMenu.vue?vue&type=template&id=6c9393b0"
import script from "./UserProfileMenu.ts?vue&type=script&lang=ts&external"
export * from "./UserProfileMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./UserProfileMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports